import React, { VFC, useCallback, useState, createRef } from 'react';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { FormBuilderPresenter } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/FormBuilderPresenter';
import { Button, Box } from '@dxb-web-ui-framework/design-system';
import { FormConfig } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/types';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { GenericDrawer } from '../../GenericDrawer';

export type TableFilterDrawerProps<T = GenericObject> = {
  formConfig: FormConfig;
  isOpen: boolean;
  // TODO: Implement correct onToggleDrawer type
  onToggleDrawer: () => void;
  onApplyDrawer: (newFilters: Partial<T>) => void;
  applyButtonLabel: string;
  title: string;
  filters?: Partial<T>;
  customFormBuilderClass?: string;
};
// TODO: Preload current selected filters if any
const TableFilterDrawer: VFC<TableFilterDrawerProps> = ({
  isOpen,
  formConfig,
  onToggleDrawer,
  onApplyDrawer,
  applyButtonLabel,
  title,
  filters,
  customFormBuilderClass,
}) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  const formRef = createRef<HTMLFormElement>();
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

  const onApply = useCallback(() => {
    const currentFilters = formRef.current?.getFormData();
    onApplyDrawer(currentFilters);
  }, [formRef, onApplyDrawer]);

  const onIsValidToggle = useCallback(
    isValid => {
      setIsSubmitEnabled(isValid);
    },
    [setIsSubmitEnabled],
  );

  return (
    <GenericDrawer
      isOpen={isOpen}
      title={title}
      stickDrawerTitleToLeft
      disableMobileDrawerHeight={true}
      anchor={isMobile ? 'bottom' : 'right'}
      onToggleDrawer={onToggleDrawer}>
      <Box px={3} py={3} height='100%' display={'flex'} flexDirection={'column'}>
        <FormBuilderPresenter
          externalFormBuilderElementWrapperClass={customFormBuilderClass}
          formConfig={{
            ...formConfig,
            preloadedData: filters,
          }}
          ref={formRef}
          onIsValidToggle={onIsValidToggle}
        />
        <Button
          color='primary'
          size='large'
          variant='contained'
          onClick={onApply}
          disabled={!isSubmitEnabled}
          fullWidth>
          {applyButtonLabel}
        </Button>
      </Box>
    </GenericDrawer>
  );
};

export { TableFilterDrawer };
